import React from 'react'
import UniLogo from "assets/AboutUniprest/wpLogo.png"
import MyLink from 'components/MyLink'
import MobileMenuItem from './MobileMenuItem'

const MobileMenu = ({ isOpen, onClose, menuItems }) => {
  if (!isOpen) return null;

  return (
    <div className="mobile-menu-overlay">
      <div className="mobile-menu-container">
        <div className="mobile-menu-header">
          <MyLink to={process.env?.REACT_APP_WORDPRESS_URL} onClick={onClose}>
            <img src={UniLogo} alt="Uniprest Logo" className="mobile-logo" />
          </MyLink>
          <button
            className="mobile-menu-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <span className="close-icon">×</span>
          </button>
        </div>
        <nav className="mobile-menu">
          <ul className="mobile-menu-items">
            {menuItems?.map?.(item => (
              <MobileMenuItem
                key={item?.id}
                item={item}
                onClose={onClose}
              />
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;